module.exports = __webpack_public_path__ + "media/images/icons/outlined/man-ba753041a4510ab7328869a04c347fab.svg";